import React from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Box,
} from '@mui/material';
import dayjs from 'dayjs';
import { avatars, colors, translations } from '.';

const forwardType = {
  schedule: 'editSchedule',
  proposal: 'editProposal',
  serviceorder: 'editServiceOrder',
};

const MonthCell = ({ children, openItem }) => {
  if (!children || children.length === 0) return null;
  const date = dayjs(children[0].datetime); 

  return (
    <Box
      onClick={() => {
        openItem({
          selectedDay: date,
          view: 'day',
          showTableDay: true,
        });
      }}
      sx={{
        position: 'relative',
        height: '100%',
        width: '100%',
        cursor: 'pointer',
      }}
    >
      <List
        dense
        onClick={(e) => e.stopPropagation()} 
        sx={{ position: 'relative', zIndex: 2 }}
      >
        {children.map((each) => (
          <ListItem key={`${each.type}-${each.id}`} disableGutters disablePadding>
            <ListItemButton
              onClick={() => openItem({ [forwardType[each.type]]: each })}
              sx={{ gap: '1rem', padding: 0, paddingLeft: '0.5rem' }}
              dense
            >
              <ListItemAvatar sx={{ minWidth: '20px' }}>
                <Avatar
                  sx={{
                    bgcolor: 'transparent',
                    color: colors[each.state],
                    height: '25px',
                    width: '25px',
                  }}
                >
                  {avatars[each.type]}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                className="calendar-item-text"
                primary={each.client_name}
                secondary={dayjs(each.datetime).format('HH:mm')}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default MonthCell;